export enum NetworkStatus {
  ONLINE = "online",
  OFFLINE = "offline",
}
